import { lazy, Suspense, useEffect, useState } from "react";
import GenreService from "services/GenreService";
import { Link } from "react-router-dom";
import { RouteName } from "constant/routeNames";
import GenreSkeleton from "../../../components/skeleton/GenreSkeleton";
import { Adsense } from "@ctrl/react-adsense";
import GeneralServices from "services/General/GeneralServices";
import SectionHeading from "components/shared/SectionHeading";

const GenreCard = lazy(() => import("../shared/GenreCard"));

const GenreSection = () => {
  const [genres, setGenres] = useState<any>([]);

  const [isLoading, setIsLoding] = useState<any>(false);
  const [gAdSlot, setgAdSlot] = useState<any>();

  useEffect(() => {
    GeneralServices.getAllConfigData()
      .then((res) => {
        const PageStatus = res?.data?.filter(
          (item: any) => item?.title === "is_music_gAd" && item?.value !== null
        );
        if (PageStatus[0]?.value === "1") {
          const filteredData = res?.data?.filter(
            (item: any) => item?.title === "gAdSquSlot" && item?.value !== null
          );
          setgAdSlot(filteredData[0]?.value);
          console.log("setgAdStatus", filteredData[0]?.value);
        }
      })
      .catch((e) => {});
  }, []);

  useEffect(() => {
    setIsLoding(true);
    GenreService.getAllGenres().then((res: any) => {
      setIsLoding(false);
      setGenres(res.data.slice(0, 6));
    });
  }, []);
  return (
    <>
      {!isLoading && (
        <Suspense fallback={<GenreSkeleton />}>
          <div>
            {gAdSlot && (
              <Adsense
                client="ca-pub-5773929890067376"
                slot="9259680441"
                style={{
                  display: "block",
                  marginBottom: "10px",
                  height: "90px",
                  justifyContent: "center",
                }}
                layout="in-article"
                data-full-width-responsive="true"
                data-ad-format="auto"
              />
            )}
            <div className="mt-4 flex w-full flex-row items-center justify-between">
              <div className="flex items-center gap-3">
                <SectionHeading text="Genre" />
              </div>
              <Link to={RouteName.SeeAllGenreRoute} className="group shrink-0">
                <p className="flex items-center gap-1 text-sm font-bold text-[#F50537] transition-all duration-200 group-hover:gap-2">
                  See all
                  <span className="transition-transform duration-200 group-hover:translate-x-0.5">
                    →
                  </span>
                </p>
              </Link>
            </div>
            <div className="grid w-full grid-cols-2 grid-rows-3 gap-3 pt-5 max-sm:grid-cols-2">
              {genres &&
                genres.map((value: any, index: number) => (
                  <GenreCard key={index} value={value} />
                ))}
            </div>
          </div>
        </Suspense>
      )}
      {isLoading && <GenreSkeleton />}
    </>
  );
};

export default GenreSection;